import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../views/Layout.vue'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Home
  },
  {
    path: '/layout',
    component: Layout,
    redirect: '/layout/main',
    children: [
      {
        path: '/layout/main',
        component: () => import('@/views/Main.vue'),
        name: 'Main'
      },
      {
        path: '/layout/main/:id',
        component: () => import('@/views/Main.vue'),
        name: 'Category'
      },
      {
        path: '/layout/news/:id',
        name: 'News',
        component: () => import('@/views/News.vue')
      },
      {
        path: '/layout/article/:type/:id',
        name: 'Article',
        component: () => import('@/views/Article.vue')
      },
      {
        path: '/layout/result/:key',
        name: 'Result',
        component: () => import('@/views/Result.vue')
      },
      {
        path: '/layout/contact/:type/:id',
        name: 'Contact',
        component: () => import('@/views/Contact.vue')
      }
    ]
  },

]

const router = new VueRouter({
  routes
})

export default router
